import { getUUIDCookie } from '@/helpers/tokens'
import { NEW_RELIC_EVENTS, NEW_RELIC_LOGGING_EVENT } from './constants'
import { events } from './events'

function createLoggingEvent(event, options) {
  const { is_successful, flow, additional_context } = options

  return {
    logger: NEW_RELIC_LOGGING_EVENT.logger,
    traceId: getUUIDCookie(),
    flow,
    event_type: event,
    is_successful,
    origin_service: NEW_RELIC_LOGGING_EVENT.originService,
    environment: process.env.TARGET_ENV || 'development',
    additional_context: {
      channel_type: NEW_RELIC_LOGGING_EVENT.channelType,
      ...additional_context,
    },
  }
}

const newRelicEventHandlers = {}

Object.values(NEW_RELIC_EVENTS).forEach(newRelicEvents => {
  newRelicEventHandlers[newRelicEvents] = ({ event, ...rest }) => {
    const $newRelicAgent = window.newrelic

    if (!$newRelicAgent) {
      return false
    }

    try {
      const eventPayload = events[event](rest)
      const loggingEvent = createLoggingEvent(event, eventPayload)

      $newRelicAgent.log(loggingEvent.event_type, {
        customAttributes: loggingEvent,
      })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error logging event to NewRelic:', error)
    }
  }
})

export { newRelicEventHandlers }
